












































































import mixins from 'vue-typed-mixins'
import usersMixin from '../usersMixin'
import mobileTypeMixin from '@/plugins/mixins/mobileTypeMixin'
import validationMixin from '@/plugins/mixins/validationMixin'
import { RoleEnum } from '@/domain/role'
import User from '@/domain/user'
import Openable from '@/global/viewmodels/openable'
import _ from 'lodash'

export default mixins(usersMixin, mobileTypeMixin, validationMixin).extend({
    props: { value: User, dialog: Openable },
    data() {
        return { expand: null }
    },
    computed: {
        isValid(): boolean {
            return this.valid && this.value && this.value.roleEnum != RoleEnum.NotSet
        },
        roleSelected(): boolean {
            return this.value.roleEnum == RoleEnum.NotSet
        },
        commerciaux(): string[] {
            let commerciaux = this.commerciauxSelection
            if(this.value.dentaire && !this.value.ortho){
                commerciaux = _.filter(this.commerciauxSelection, (a) => a.dentaire)
            }
            if(!this.value.dentaire && this.value.ortho){
                commerciaux = _.filter(this.commerciauxSelection, (a) => a.ortho)
            }

            return _.map(commerciaux, (a) => a.nom)
        }
    },
    methods: {
        saveUser() {
            this.sauvegarder(this.value, this.isValid, this.dialog)
            this.dialog.close()
        },
        clientChanged() {
            this.$emit('clientChanged')
        },
        roleChanged() {
            this.$emit('roleChanged')
        }
    }
})
